import { useEffect, useRef, useState } from "react";

export const useIsOverflowing = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (ref.current) setIsOverflowing(ref.current.scrollWidth > ref.current.clientWidth);
  }, [ref.current]);

  return { ref, isOverflowing };
};
